// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { VersionDetailSpa as default } from './ui';
